import { render, staticRenderFns } from "./PseudoIdentifyPopup.vue?vue&type=template&id=6a85c2ae&scoped=true&"
import script from "./PseudoIdentifyPopup.vue?vue&type=script&lang=js&"
export * from "./PseudoIdentifyPopup.vue?vue&type=script&lang=js&"
import style0 from "./PseudoIdentifyPopup.vue?vue&type=style&index=0&id=6a85c2ae&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a85c2ae",
  null
  
)

export default component.exports